<template>
  <svg viewBox="0 0 480 1300" preserveAspectRatio="xMinYMin slice" x="0" y="0">
    <g opacity=".15">
      <path
        d="M480 1293.5v-14.3L86.4 886 480 492.8v-14.3L72 886z"
        class="st1"
        style="fill: #376e8c; fill-rule: evenodd; clip-rule: evenodd"
      />
      <path
        d="M460.4 1300h13.7L59.7 886.6 480 467.1v-13.7L46 886.6z"
        class="st1"
        style="fill: #376e8c; fill-rule: evenodd; clip-rule: evenodd"
      />
      <path
        d="M480 1215.5v-16.4L166.4 886 480 572.9v-16.4L150 886z"
        class="st1"
        style="fill: #376e8c; fill-rule: evenodd; clip-rule: evenodd"
      />
      <path
        d="M480 1242.5v-15.7L138.7 886 480 545.1v-15.6L123 886z"
        class="st1"
        style="fill: #376e8c; fill-rule: evenodd; clip-rule: evenodd"
      />
      <path
        d="M480 1267.9v-15L114 886.5l366-366.4v-15L99 886.5zM367.3 1300L0 933.1V944l356.4 356z"
        class="st1"
        style="fill: #376e8c; fill-rule: evenodd; clip-rule: evenodd"
      />
      <path
        d="M480 1189v-17.1L194 886l286-285.9V583L177 886zM0 866.2l480-480.5V374L0 854.5zM0 812.4l480-479.6v-10.3L0 802.1zM392.7 1300L0 907v11.6L381.1 1300zM340.6 1300L0 959.7V970l330.3 330zM0 839l480-479.6v-10.9L0 828.1z"
        class="st1"
        style="fill: #376e8c; fill-rule: evenodd; clip-rule: evenodd"
      />
      <path
        d="M480 956v-23.1L433.1 886l46.9-46.9V816l-70 70z"
        class="st1"
        style="fill: #376e8c; fill-rule: evenodd; clip-rule: evenodd"
      />
      <path
        d="M480 929v-23.8L460.8 886l19.2-19.2V843l-43 43z"
        class="st1"
        style="fill: #376e8c; fill-rule: evenodd; clip-rule: evenodd"
      />
      <path
        d="M480 1008.5v-21.9L379.8 886.5 480 786.4v-21.9l-122 122z"
        class="st1"
        style="fill: #376e8c; fill-rule: evenodd; clip-rule: evenodd"
      />
      <path
        d="M480 1164.9v-17.7L219.7 886.5 480 625.8v-17.7L202 886.5z"
        class="st1"
        style="fill: #376e8c; fill-rule: evenodd; clip-rule: evenodd"
      />
      <path
        d="M480 904.5v-36l-18 18zM420.3 1300L6.3 886.1 480 412.3V400L0 880.1v12L408 1300z"
        class="st1"
        style="fill: #376e8c; fill-rule: evenodd; clip-rule: evenodd"
      />
      <path
        d="M480 982.5v-22.6l-73.4-73.4 73.4-73.4v-22.6l-96 96z"
        class="st1"
        style="fill: #376e8c; fill-rule: evenodd; clip-rule: evenodd"
      />
      <path
        d="M480 1137.6v-18.5L246.4 886 480 652.9v-18.5L228 886z"
        class="st1"
        style="fill: #376e8c; fill-rule: evenodd; clip-rule: evenodd"
      />
      <path
        d="M480 1111.6v-19.1L273.1 886 480 679.5v-19L254 886z"
        class="st1"
        style="fill: #376e8c; fill-rule: evenodd; clip-rule: evenodd"
      />
      <path
        d="M480 1034v-21.1L354.1 887 480 761.1V740L333 887z"
        class="st1"
        style="fill: #376e8c; fill-rule: evenodd; clip-rule: evenodd"
      />
      <path
        d="M480 1085v-19.8L300.8 886 480 706.8V687L281 886z"
        class="st1"
        style="fill: #376e8c; fill-rule: evenodd; clip-rule: evenodd"
      />
      <path
        d="M480 1060v-20.5L327.4 887 480 734.5V714L307 887z"
        class="st1"
        style="fill: #376e8c; fill-rule: evenodd; clip-rule: evenodd"
      />
      <path
        d="M434.4 1300h13L33 886.1l447-446.7v-12.9L20 886.1zM0 572.4L480 92.7v-4.2L0 568.3zM125.1 1300L0 1175v4.9L120.2 1300zM100.3 1300L0 1199.7v4.2l96.2 96.1zM0 599.1l480-479.7v-4.9L0 594.3zM153.8 1300L0 1146.3v5.6L148.3 1300zM0 546.9L480 66.5v-3.4L0 543.4zM0 625.8l480-479.7v-5.6L0 620.3zM20.3 1300L0 1279.7v2.1l18.2 18.2zM0 492.4L480 12.6v-2.1L0 490.3zM47 1300l-47-47v2.8l44.2 44.2zM0 519.1L480 39.3v-2.7L0 516.3zM73.7 1300L0 1226.3v3.4l70.2 70.3zM207.1 1300L0 1093.1v6.8L200.3 1300zM180.5 1300L0 1119.7v6.2L174.3 1300zM286.1 1300L0 1013.8v8.9L277.2 1300zM0 732.4l480-479.7v-8.2L0 724.2zM313.1 1300L0 987v9.6L303.5 1300zM0 759.4L480 279v-8.9L0 750.5zM260.5 1300L0 1039.7v8.2L252.3 1300zM0 652.5l480-479.8v-6.2L0 646.2zM0 786.2l480-480.1v-9.6L0 776.6zM0 705.8l480-479.7v-7.6L0 698.2zM233.9 1300L0 1066.3v7.6L226.3 1300zM0 679.1l480-479.7v-6.9L0 672.2z"
        class="st1"
        style="fill: #376e8c; fill-rule: evenodd; clip-rule: evenodd"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'DrawerStripes',
}
</script>
